import TwoSum from "./Problems/TwoSum";
import ThreeSum from "./Problems/ThreeSum";
import FourSum from "./Problems/FourSum";
import FlattenArray from "./Problems/FlattenArray";
import FlattenArray2 from "./Problems/FlattenArray2";
import ArrayMap from "./Problems/ArrayMap";
import ArrayFilter from "./Problems/ArrayFilter";
import LeastFrequent from "./Problems/LeastFrequentArray";
import MostFrequent from "./Problems/MostFrequentArray";
import InvertKeyValue from "./Problems/InvertKeyValue";
import DeepFilterObject from "./Problems/DeepFilterObject";
import DeepFlattenObject from "./Problems/DeepFlattenObject";
import ElementWithKFrequency from "./Problems/ArrayElementWithKFrequency";
import ValidPalindrome from "./Problems/ValidPalindrome";
import MergeIntervals from "./Problems/MergeIntervals";
import CaeserCipher from "./Problems/CeaserCipher";
import CaeserCipher2 from "./Problems/CeaserCipher2";
import LongestCommonSubsequence from "./Problems/LongestCommonSubsequence";
import LongestRepeatedSubsequence from "./Problems/LongestRepeatedSubsequence";
import LongestConsecutiveSubsequence from "./Problems/LongestConsecutiveSubsequence";
import LongestPalindromicSubsequence from "./Problems/LongestPalindromicSubsequence";
import CheckInteger from "./Problems/CheckInteger";
import ChopArray from "./Problems/ChopArray";
import ChopString from "./Problems/ChopString";
import ConvertTime from "./Problems/ConvertTime";
import DiffDates from "./Problems/DiffDates";
import ReverseWordsInString from "./Problems/ReverseWordsInString";
import StringWithDigits from "./Problems/StringWithDigits";
import ValidateMobileNumber from "./Problems/ValidateMobileNumber";

const problemsList = [
  { ...TwoSum },
  { ...ThreeSum },
  { ...FourSum },
  { ...FlattenArray },
  { ...FlattenArray2 },
  { ...ArrayMap },
  { ...ArrayFilter },
  { ...LeastFrequent },
  { ...MostFrequent },
  { ...InvertKeyValue },
  { ...DeepFilterObject },
  { ...DeepFlattenObject },
  { ...ElementWithKFrequency },
  { ...ValidPalindrome },
  { ...MergeIntervals },
  { ...CaeserCipher },
  { ...CaeserCipher2 },
  { ...LongestCommonSubsequence },
  { ...LongestRepeatedSubsequence },
  { ...LongestConsecutiveSubsequence },
  { ...LongestPalindromicSubsequence },
  { ...CheckInteger },
  { ...ChopArray },
  { ...ChopString },
  { ...ConvertTime },
  { ...DiffDates },
  { ...ReverseWordsInString },
  { ...StringWithDigits },
  { ...ValidateMobileNumber },
];

export default problemsList;
